namespace $.$$ {

	$mol_style_define( $shm_hitalama_process_logs, {

		display: 'flex',
		flex: {
			direction: 'column',
		},
		gap: $mol_gap.block,
		padding: $mol_gap.block,

		Head: {
			display: 'flex',
			align: {
				items: 'center',
			},
			gap: $mol_gap.text,
		},

		Title: {
			font: {
				size: '1.1rem',
				weight: 600,
			},
		},

		Empty: {
			color: $mol_theme.shade,
			padding: $mol_gap.block,
			background: {
				color: $mol_theme.card,
			},
			border: {
				radius: $mol_gap.round,
			},
		},

		List: {
			gap: $mol_gap.text,
		},

	} )

}
